import { useTranslation } from 'react-i18next';

import type { IValueChainHeader } from './interfaces/IValueChainHeader';

import styles from './sass/ValueChainHeader.module.scss';

function ValueChainHeader({
  title,
  description,
  selectedCount,
  totalCount,
  hideCounter,
}: IValueChainHeader) {
  const { t } = useTranslation();

  return (
    <div className={styles.vcHeader}>
      <span className={styles.vcHeaderTitle}>{title}</span>
      <div className={styles.wrapperDescription}>
        <span className={styles.description}>{description}</span>
        {!hideCounter && (
          <span className={styles.counter}>
            {`${t('materialityAssessment.selected')} ${selectedCount}/${totalCount}`}
          </span>
        )}
      </div>
    </div>
  );
}

export default ValueChainHeader;
